import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Snackbar from '@material-ui/core/Snackbar';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { deleteAlert } from '../actions/alerts.action';
import MuiAlert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Slide from '@material-ui/core/Slide';

function SlideTransition(props) {
  if (props.in) {
    return <Slide
      { ...props } direction="up"/>;
  } else {
    return <Slide { ...props } direction="right"/>;
  }
}

export default function PositionedSnackbar() {
  const { t } = useTranslation();
  const alerts = useSelector(state => state.alerts);
  const [ open, setOpen ] = useState(true);

  const dispatch = useDispatch();

  const handleClose = () => {
    if (alerts.length === 1) {
      setOpen(false);
      dispatch(deleteAlert());
      setTimeout(setOpen(true), 200);
    } else {
      setOpen(false);
      dispatch(deleteAlert());
    }
  };

  const onExited = () => {
    setOpen(true);
  };

  const useStyles = makeStyles(theme => ({
    snack: {
      minWidth: '400px',
      marginBottom: '30px',
      [theme.breakpoints.down('xs')]: {
        minWidth: '100px'
      }
    },
    fakeSnack: {
      minWidth: '400px',
      [theme.breakpoints.down('xs')]: {
        minWidth: '300px'
      }
    }
  }));

  const classes = useStyles();

  return (
    <>
      {alerts.length > 0 &&
      <>
        <Snackbar open={ open }
          TransitionComponent={ SlideTransition }
          onExited={ onExited }
          anchorOrigin = { {
            vertical: 'bottom',
            horizontal: 'center'
          } }
          transitionDuration = {
            { enter: 200,
              exit: 200 }
          }
        >
          <MuiAlert
            className = { classes.snack }
            variant="filled"
            onClose={ handleClose }
            severity={ alerts[alerts.length - 1].severity }>
            { t(alerts[alerts.length - 1].message )}
          </MuiAlert>
        </Snackbar>
        { alerts.length > 1 &&
          <Snackbar open={ open }
            TransitionProps={ {
              appear: false
            } }
            anchorOrigin = { {
              vertical: 'bottom',
              horizontal: 'center'
            } }
          >
            <Collapse in={ false } collapsedHeight= { 20 } className = { classes.fakeSnack } >
              <MuiAlert
                className = { classes.fakeSnack }
                variant="filled"
                severity={ alerts[alerts.length - 2].severity }>
                { alerts[alerts.length - 2].message }
              </MuiAlert>
            </Collapse>
          </Snackbar>}
      </>
      }</>
  );
}